/** The calorie ring: eaten against target, with the remaining number in the
 *  middle — the one figure a person actually wants at dinner time. */

import { fmtKcal } from '../../lib/nutrients'

export function Ring({ eaten, target, size = 150 }: { eaten: number; target: number | null; size?: number }) {
  const r = size / 2 - 10
  const c = 2 * Math.PI * r
  const frac = target ? Math.min(1, eaten / target) : 0
  const over = target !== null && eaten > target * 1.0
  const left = target !== null ? Math.round(target - eaten) : null
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img"
      aria-label={target ? `${fmtKcal(eaten)} of ${fmtKcal(target)} kcal eaten` : `${fmtKcal(eaten)} kcal eaten`}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--track)" strokeWidth="11" />
      {/* Skipped at zero: a zero-length stroke with round caps still draws a dot. */}
      {target !== null && frac > 0 && (
        <circle cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke={over ? 'var(--warn)' : 'var(--accent)'} strokeWidth="11" strokeLinecap="round"
          strokeDasharray={`${c * frac} ${c}`} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      )}
      <text x="50%" y="46%" textAnchor="middle" fontSize="26" fontWeight="650" fill="var(--text)">
        {left === null ? fmtKcal(eaten) : fmtKcal(Math.abs(left))}
      </text>
      <text x="50%" y="62%" textAnchor="middle" fontSize="11.5" fill="var(--muted)">
        {left === null ? 'kcal eaten' : left >= 0 ? 'kcal left' : 'kcal over'}
      </text>
    </svg>
  )
}
